import React, { useState, useEffect, useContext } from "react";
import axiosInstance from "../axiosInstance";
import { useNavigate } from "react-router-dom";
import AuthContext from "../AuthContext";
import { FaArrowUp } from "react-icons/fa";
import io from "socket.io-client";

// const socket = io(process.env.REACT_APP_BASE_API_URL, {
//   withCredentials: true, // Ensure CORS headers are handled
// });

const LiveOrdersPage = () => {
  // Static order data
  const { isLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);

  const [cancelReason, setCancelReason] = useState("");
  const [showCancelReasonModal, setShowCancelReasonModal] = useState(false);
  const [orderToCancel, setOrderToCancel] = useState(null);
  const [showButton, setShowButton] = useState(false);

  //Load sound
  const beepSound = new Audio("/beep.mp3"); 

  //if user is not logged in, redirect to login page
  useEffect(() => {
    if (!isLoggedIn) {
      console.log("User is not logged in. Redirecting to login page.");
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // // Fetch orders on page load
  // useEffect(() => {
  //   fetchOrders();
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   socket.emit("joinRestaurant", user.restaurantId);

  //   // Confirm socket connection
  //   socket.on("connect", () => {
  //     console.log("Socket connected");
  //     socket.emit("joinRestaurant", user.restaurantId);
  //   });

  //   // Handle new order and updated order
  //   socket.on("newOrder", (newOrder) => {
  //     setOrders((prevOrders) => [newOrder, ...prevOrders]);
  //   });

  //   socket.on("order_updated", (updatedOrder) => {
  //     setOrders((prevOrders) =>
  //       prevOrders.map((order) =>
  //         order._id === updatedOrder._id ? updatedOrder : order
  //       )
  //     );
  //   });

  //   socket.on("connect_error", (error) => {
  //     console.error("Socket connection error:", error);
  //   });

  //   return () => {
  //     socket.off("newOrder");
  //     socket.off("order_updated");
  //   };
  // }, [isLoggedIn, navigate]);

  // Fetch orders on page load and every 10 seconds

  useEffect(() => {
    const fetchOrders = async () => {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user.restaurantId) {
        console.error("Restaurant ID not found in local storage");
        return;
      }
      try {
        const response = await axiosInstance.get(
          `/api/orders?restaurantId=${user.restaurantId}`
        );
        
       setOrders(response.data);

      } catch (error) {
        console.error("Error fetching orders:", error);
        if ((error.response.data = "Token is required")) {
          navigate("/login");
        }
      }
    };

    fetchOrders(); // Initial fetch on component mount
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user.restaurantId) {
        console.error("Restaurant ID not found in local storage");
        return;
      }
      try {
        const response = await axiosInstance.get(
          `/api/orders?restaurantId=${user.restaurantId}`
        );

         // Check if there are new orders
         const newOrders = response.data.filter(
          (order) =>
            order.status === "new");
          console.log("New orders:", newOrders);
        if (newOrders.length > 0) {
          // Play sound for new orders
          console.log("Playing beep sound for new orders");
          beepSound.play();
        }


        setOrders(response.data);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    const interval = setInterval(() => {
      fetchOrders();
    }, 20000); // Fetch new orders every 10 seconds

    return () => clearInterval(interval); // Cleanup
  }, []);

  // Function to update the status of an order
  const handleStatusChange = async (orderId, newStatus, reason = null) => {
    const updatedOrders = orders.map((order) =>
      order._id === orderId
        ? { ...order, status: newStatus, cancellationReason: reason }
        : order
    );
    // Update the status of the order in the backend
    try {
      await axiosInstance.put(`/api/orders/${orderId}`, {
        status: newStatus,
        cancellationReason: reason,
      });
    } catch (error) {
      console.error("Error updating order status:", error);
      if ((error.response.data = "Token is required")) {
        navigate("/login");
      }
    }

    setOrders(updatedOrders);
    setShowCancelReasonModal(false);
  };

  // Open the cancellation reason modal
  const handleCancelClick = (order) => {
    setOrderToCancel(order);
    setShowCancelReasonModal(true);
  };

  // Handle the reason submission
  const handleCancelReasonSubmit = () => {
    handleStatusChange(orderToCancel._id, "canceled", cancelReason);
    setCancelReason("");
  };

  const handleHideChange = async (orderId) => {
    const updatedOrders = orders.map((order) =>
      order._id === orderId ? { ...order, hide: true } : order
    );
    setOrders(updatedOrders);

    // Update the status of the order in the backend
    try {
      await axiosInstance.put(`/api/orders/hide/${orderId}`, {
        hide: true,
      });
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-white py-10">
      {showButton && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-5 right-5 p-3 rounded-full shadow-lg hover:opacity-90 transition-opacity"
          style={{
            background: "linear-gradient(to right, #6A5ACD, #00BFFF)", // Gradient color
            color: "white",
            zIndex: 1000,
          }}
        >
          <FaArrowUp size={20} /> {/* FontAwesome arrow up icon */}
        </button>
      )}
      <div className="container mx-auto px-6">
        <h1 className="text-4xl font-bold text-black text-center mb-10">
          Live Orders
        </h1>

        <div className="flex flex-col md:flex-row justify-center space-y-2 md:space-y-0 md:space-x-4">
          <button
            className="bg-blue-500 text-white px-4 py-2 w-full md:w-auto rounded text-center"
            onClick={() => scrollToSection("newordersection")}
          >
            New Orders
          </button>
          <button
            className="bg-blue-500 text-white px-4 py-2 w-full md:w-auto rounded text-center"
            onClick={() => scrollToSection("preparingsection")}
          >
            Preparing
          </button>
          <button
            className="bg-blue-500 text-white px-4 py-2 w-full md:w-auto rounded text-center"
            onClick={() => scrollToSection("Deliveredtothetable")}
          >
            Delivered to the table
          </button>
          <button
            className="bg-blue-500 text-white px-4 py-2 w-full md:w-auto rounded text-center"
            onClick={() => scrollToSection("paidordersection")}
          >
            Paid Orders
          </button>
          <button
            className="bg-blue-500 text-white px-4 py-2 w-full md:w-auto rounded text-center"
            onClick={() => scrollToSection("canceledOrderSection")}
          >
            Canceled Orders
          </button>
        </div>

        {/* New Orders Section */}
        <h2
          id="newordersection"
          className="text-3xl font-semibold text-black mb-4"
        >
          New Orders
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {orders
            .filter((order) => order.status === "new")
            .map((order) => (
              <div
                key={order._id}
                className="bg-gray-100 shadow-lg rounded-lg p-4 min-h-[300px] max-h-[350px] overflow-y-auto"
              >
                <h2 className="text-lg font-semibold text-black mb-2">
                  Table {order.tableNumber}
                </h2>
                <p className="text-gray-700 -mt-2 text-sm ">
                  <strong>Customer:</strong> {order.customerDetails.name}
                  <br />
                  <strong>Phone:</strong> {order.customerDetails.phone}
                </p>
                <p className="text-gray-700 text-sm">
                  <strong>Order Time:</strong>{" "}
                  {new Date(order.orderDate).toLocaleString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </p>
                <strong>Items:</strong>
                <ul className="ml-4 text-red-600">
                  {order.foodDetails.map((item, index) => (
                    <li key={index} className="mb-2">
                      <div>
                        <span className="font-semibold">
                          - {item.name} ${item.price}
                        </span>
                        {"        "}
                        <span className="ml-4">x {item.quantity}</span>
                      </div>
                      {item.selectedExtras &&
                        item.selectedExtras.length > 0 && (
                          <ul className="ml-6 text-sm text-gray-500">
                            {item.selectedExtras.map((extra, extraIndex) => (
                              <li key={extraIndex} className="italic">
                                • Extra: {extra.name} (${extra.price})
                              </li>
                            ))}
                            {item.notes && (
                              <span className="italic ">
                                • Notes: {item.notes}
                              </span>
                            )}
                          </ul>
                        )}
                    </li>
                  ))}
                </ul>

                <p className="mt-2 text-gray-700">
                  <strong>Total:</strong> ${order.total.toFixed(2)}
                </p>

                {/* Status Controls */}
                <div className="mt-4">
                  <button
                    onClick={() => handleStatusChange(order._id, "preparing")}
                    className="bg-green-500 text-white px-4 py-2 rounded mr-2"
                  >
                    Mark as preparing
                  </button>
                  <button
                    onClick={() => handleCancelClick(order)}
                    className="bg-red-500 text-white px-4 py-2 rounded"
                  >
                    Cancel Order
                  </button>
                </div>
              </div>
            ))}
        </div>

        {/* Divider Line */}
        <div className="border-t border-gray-300 my-10"></div>
        {/* New Orders Section */}
        <h2
          id="preparingsection"
          className="text-3xl font-semibold text-black mb-4"
        >
          Preparing
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {orders
            .filter((order) => order.status === "preparing")
            .map((order) => (
              <div
                key={order._id}
                className="bg-gray-100 shadow-lg rounded-lg p-4 min-h-[300px] max-h-[350px] overflow-y-auto"
              >
                <h2 className="text-lg font-semibold text-black mb-2">
                  Table {order.tableNumber}
                </h2>
                <p className="text-gray-700 -mt-2 text-sm ">
                  <strong>Customer:</strong> {order.customerDetails.name}
                  <br />
                  <strong>Phone:</strong> {order.customerDetails.phone}
                </p>
                <p className="text-gray-700 text-sm">
                  <strong>Order Time:</strong>{" "}
                  {new Date(order.orderDate).toLocaleString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </p>
                <strong>Items:</strong>
                <ul className="ml-4 text-red-600">
                  {order.foodDetails.map((item, index) => (
                    <li key={index} className="mb-2">
                      <div>
                        <span className="font-semibold">
                          - {item.name} ${item.price}
                        </span>
                        {"        "}
                        <span className="ml-4">x {item.quantity}</span>
                      </div>
                      {item.selectedExtras &&
                        item.selectedExtras.length > 0 && (
                          <ul className="ml-6 text-sm text-gray-500">
                            {item.selectedExtras.map((extra, extraIndex) => (
                              <li key={extraIndex} className="italic">
                                • Extra: {extra.name} (${extra.price})
                              </li>
                            ))}
                            {item.notes && (
                              <span className="italic ">
                                • Notes: {item.notes}
                              </span>
                            )}
                          </ul>
                        )}
                    </li>
                  ))}
                </ul>

                <p className="mt-2 text-gray-700">
                  <strong>Total:</strong> ${order.total.toFixed(2)}
                </p>

                {/* Status Controls */}
                <div className="mt-4">
                  <button
                    onClick={() => handleStatusChange(order._id, "delivered")}
                    className="bg-green-500 text-white px-4 py-2 rounded mr-2"
                  >
                    Delivered to the table
                  </button>
                  <button
                    onClick={() => handleCancelClick(order)}
                    className="bg-red-500 text-white px-4 py-2 rounded"
                  >
                    Cancel Order
                  </button>
                </div>
              </div>
            ))}
        </div>

        {/* Divider Line */}
        <div className="border-t border-gray-300 my-10"></div>
        {/* New Orders Section */}
        <h2
          id="Deliveredtothetable"
          className="text-3xl font-semibold text-black mb-4"
        >
          Delivered to the table
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {orders
            .filter((order) => order.status === "delivered")
            .map((order) => (
              <div
                key={order._id}
                className="bg-gray-100 shadow-lg rounded-lg p-4 min-h-[300px] max-h-[350px] overflow-y-auto"
              >
                <h2 className="text-lg font-semibold text-black mb-2">
                  Table {order.tableNumber}
                </h2>
                <p className="text-gray-700 -mt-2 text-sm ">
                  <strong>Customer:</strong> {order.customerDetails.name}
                  <br />
                  <strong>Phone:</strong> {order.customerDetails.phone}
                </p>
                <p className="text-gray-700 text-sm">
                  <strong>Order Time:</strong>{" "}
                  {new Date(order.orderDate).toLocaleString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </p>
                <strong>Items:</strong>
                <ul className="ml-4 text-red-600">
                  {order.foodDetails.map((item, index) => (
                    <li key={index} className="mb-2">
                      <div>
                        <span className="font-semibold">
                          - {item.name} ${item.price}
                        </span>
                        {"        "}
                        <span className="ml-4">x {item.quantity}</span>
                      </div>
                      {item.selectedExtras &&
                        item.selectedExtras.length > 0 && (
                          <ul className="ml-6 text-sm text-gray-500">
                            {item.selectedExtras.map((extra, extraIndex) => (
                              <li key={extraIndex} className="italic">
                                • Extra: {extra.name} (${extra.price})
                              </li>
                            ))}
                            {item.notes && (
                              <span className="italic ">
                                • Notes: {item.notes}
                              </span>
                            )}
                          </ul>
                        )}
                    </li>
                  ))}
                </ul>

                <p className="mt-2 text-gray-700">
                  <strong>Total:</strong> ${order.total.toFixed(2)}
                </p>

                {/* Status Controls */}
                <div className="mt-4">
                  <button
                    onClick={() => handleStatusChange(order._id, "paid")}
                    className="bg-green-500 text-white px-4 py-2 rounded mr-2"
                  >
                    Paid
                  </button>
                  <button
                    onClick={() => handleCancelClick(order)}
                    className="bg-red-500 text-white px-4 py-2 rounded"
                  >
                    Cancel Order
                  </button>
                </div>
              </div>
            ))}
        </div>

        {/* Divider Line */}
        <div className="border-t border-gray-300 my-10"></div>

        {/* Completed/Canceled Orders Section */}
        <h2
          id="paidordersection"
          className="text-3xl font-semibold text-black mb-4"
        >
          Paid Orders
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {orders
            .filter((order) => order.status === "paid" && !order.hide)
            .map((order) => (
              <div
                key={order._id}
                className="bg-gray-100 shadow-lg rounded-lg p-4 min-h-[300px] max-h-[350px] overflow-y-auto"
              >
                <h2 className="text-lg font-semibold text-black mb-2">
                  Table {order.tableNumber}
                </h2>
                <p className="text-gray-700 -mt-2 text-sm ">
                  <strong>Customer:</strong> {order.customerDetails.name}
                  <br />
                  <strong>Phone:</strong> {order.customerDetails.phone}
                </p>
                <p className="text-gray-700 text-sm">
                  <strong>Order Time:</strong>{" "}
                  {new Date(order.orderDate).toLocaleString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </p>
                <strong>Items:</strong>
                <ul className="ml-4 text-red-600">
                  {order.foodDetails.map((item, index) => (
                    <li key={index} className="mb-2">
                      <div>
                        <span className="font-semibold">
                          - {item.name} ${item.price}
                        </span>
                        {"        "}
                        <span className="ml-4">x {item.quantity}</span>
                      </div>
                      {item.selectedExtras &&
                        item.selectedExtras.length > 0 && (
                          <ul className="ml-6 text-sm text-gray-500">
                            {item.selectedExtras.map((extra, extraIndex) => (
                              <li key={extraIndex} className="italic">
                                • Extra: {extra.name} (${extra.price})
                              </li>
                            ))}
                            {item.notes && (
                              <span className="italic ">
                                • Notes: {item.notes}
                              </span>
                            )}
                          </ul>
                        )}
                    </li>
                  ))}
                </ul>

                <p className="mt-2 text-gray-700">
                  <strong>Total:</strong> ${order.total.toFixed(2)}
                </p>

                {/* Status Controls */}
                <div className="mt-4">
                  <button
                    onClick={() => handleHideChange(order._id)}
                    className="bg-red-500 text-white px-4 py-2 rounded mr-2"
                  >
                    Hide
                  </button>
                </div>
              </div>
            ))}
        </div>

        {/* Divider Line */}
        <div className="border-t border-gray-300 my-10"></div>

        {/* Completed/Canceled Orders Section */}
        <h2
          id="canceledOrderSection"
          className="text-3xl font-semibold text-black mb-4"
        >
          Canceled Orders
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {orders
            .filter((order) => order.status === "canceled" && !order.hide)
            .map((order) => (
              <div
                key={order._id}
                className="bg-gray-100 shadow-lg rounded-lg p-4 min-h-[300px] max-h-[350px] overflow-y-auto"
              >
                <h2 className="text-lg font-semibold text-black mb-2">
                  Table {order.tableNumber}
                </h2>
                <p className="text-gray-700 -mt-2 text-sm ">
                  <strong>Customer:</strong> {order.customerDetails.name}
                  <br />
                  <strong>Phone:</strong> {order.customerDetails.phone}
                </p>
                <p className="text-gray-700 text-sm">
                  <strong>Order Time:</strong>{" "}
                  {new Date(order.orderDate).toLocaleString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </p>
                <strong>Items:</strong>
                <ul className="ml-4 text-red-600">
                  {order.foodDetails.map((item, index) => (
                    <li key={index} className="mb-2">
                      <div>
                        <span className="font-semibold">
                          - {item.name} ${item.price}
                        </span>
                        {"        "}
                        <span className="ml-4">x {item.quantity}</span>
                      </div>
                      {item.selectedExtras &&
                        item.selectedExtras.length > 0 && (
                          <ul className="ml-6 text-sm text-gray-500">
                            {item.selectedExtras.map((extra, extraIndex) => (
                              <li key={extraIndex} className="italic">
                                • Extra: {extra.name} (${extra.price})
                              </li>
                            ))}
                            {item.notes && (
                              <span className="italic ">
                                • Notes: {item.notes}
                              </span>
                            )}
                          </ul>
                        )}
                    </li>
                  ))}
                </ul>

                <p className="mt-2 text-gray-700">
                  <strong>Total:</strong> ${order.total.toFixed(2)}
                </p>
                {order.cancellationReason && (
                  <p className="mt-2 text-red-600">
                    <strong>Cancelled reason:</strong>{" "}
                    {order.cancellationReason}
                  </p>
                )}
                {/* Status Controls */}
                <div className="mt-4">
                  <button
                    onClick={() => handleHideChange(order._id)}
                    className="bg-red-500 text-white px-4 py-2 rounded mr-2"
                  >
                    Hide
                  </button>
                </div>
                {/* Status Controls */}
                <div className="mt-4">
                  <button
                    onClick={() => handleStatusChange(order._id, "new")}
                    className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
                  >
                    Restore
                  </button>
                </div>
              </div>
            ))}
        </div>

        {/* Cancel Reason Modal */}
        {showCancelReasonModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75">
            <div className="bg-white p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-4">Cancel Order</h3>
              <p>Please provide a reason for canceling the order:</p>
              <textarea
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
                className="w-full border p-2 mt-2 rounded"
                rows="4"
                placeholder="Enter cancellation reason"
              ></textarea>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={handleCancelReasonSubmit}
                  className="bg-red-500 text-white px-4 py-2 rounded mr-2"
                >
                  Submit
                </button>
                <button
                  onClick={() => setShowCancelReasonModal(false)}
                  className="bg-gray-500 text-white px-4 py-2 rounded"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LiveOrdersPage;
